/** should query string be considered valid */
export const isAutoListQueryValid = (query?: string) => true;
